import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import AdminMenu from '../../components/Layout/AdminMenu'
import toast from "react-hot-toast";
import axios from 'axios';
import CategoryForm from '../../components/Form/CategoryForm';
import { Modal } from 'antd';
const CreateCategory = () => {
    const [categories, setCategories]= useState([]);
    const [name, setName] = useState('');
    const [visible, setVisible]= useState(false);
    const [selected, setSelected] = useState(null);
    const [updatedName, setUpdatedName] = useState('');
    //handle form
    const handleSubmit = async(e)=>{
        e.preventDefault();
        try {
            const {data} = await axios.post('https://bablu-server.onrender.com/api/create-category',{name})
            if(data.success){
                toast.success(`${name} is Created.`)
                getAllCategory();
            }else{
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error('something went wrong!')
        }
    }
    //get all categories
    const getAllCategory = async()=>{
        try{
            const {data} = await axios.get('https://bablu-server.onrender.com/api/get-category');
            if(data?.success){
                setCategories(data.category);
            }
        }catch(error){
            console.log(error);
            toast.error('something went wrong in getting Category!');
        }
    }
    useEffect(()=>{
        getAllCategory();
    },[]);

    //update Category
    const handleUpdate = async(e)=>{
        e.preventDefault();
        try {
            // console.log(e);
            const {data} = await axios.put(`https://bablu-server.onrender.com/api/update-category/${selected._id}`, {name:updatedName})
            if(data.success){
                toast.success(`${updatedName} is updated.`);
                setSelected(null);
                setUpdatedName('');
                setVisible(false);
                getAllCategory();
            }else{
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error('Error updating in category Update');
        }
    }

    //Delete Category
    const handleDelete = async(pId)=>{
        try {
            // console.log(e);
            const {data} = await axios.delete(`https://bablu-server.onrender.com/api/delete-category/${pId}`, {name:updatedName})
            if(data.success){
                toast.success('Category is deleted.');
                getAllCategory();
            }else{
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error('Error updating in category Update');
        }
    }
  return (
   <Layout>
    <div className="container-fluid m-3">
        <div className="row">
            <div className="col-md-3">
                <AdminMenu/>
            </div>
            <div className="col-md-8 w-60">
               Manage Category
               <div className="p-3">
                <CategoryForm handleSubmit={handleSubmit} value={name} setValue={setName}/>
               </div>
                <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories?.map((c) => (
                    <>
                      <tr>
                        <td key={c._id}>{c.name}</td>
                        <td>
                          <button
                            className="btn btn-primary ms-2"
                            onClick={() => {
                              setVisible(true);
                              setUpdatedName(c.name);
                              setSelected(c);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger ms-2"
                            onClick={() => {
                              handleDelete(c._id);
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
            <Modal onCancel={()=>setVisible(false)} footer={null} visible={visible}>
                    <CategoryForm value={updatedName} setValue={setUpdatedName} handleSubmit={handleUpdate}/>
            </Modal>
        </div>
    </div>
   </Layout>
  )
}

export default CreateCategory